var _module = require('../../module');
var _ = require('lodash');

require('../../../services/add-email-modal');
require('../../../services/analytics');

_module.component('notificationSettings', {
    controllerAs: 'notificationSettings',
    controller: [
        '$log',
        '$scope',
        '$timeout',
        '$stateParams',
        '$user',
        '$q',
        '$fsloading',
        '$thankyouModal',
        '$errorModal',
        '$addEmailModal',
        '$verifyModal',
        '$location',
        '$analytics',
        '$filter',

        function notificationSettingsCtrl($log, $scope, $timeout, $stateParams, $user, $q, $fsloading, $thankyouModal, $errorModal, $addEmailModal, $verifyModal, $location, $analytics, $filter) {
            var _this = this;

            var hasVerified = function (type) {
                if(!!type && $user && $user.hasOwnProperty('verified')) {
                    return !!$user.verified[type];
                } else {
                    return false;
                }
            };

            var getMatchScoreClasses = function () {
                var r = [
                    {label:'great', value: true},
                    {label: 'good', value: true},
                    {label: 'poor', value: false}
                ];

                if(_.has($user, 'settings.alerts.match_score_classes')) {
                    angular.forEach(r, function (matchScoreClass, i) {
                        matchScoreClass['value'] = $user.settings.alerts.match_score_classes.indexOf(matchScoreClass['label']) > -1;
                    }, r);
                }
                return r;
            };

            var setMatchScoreClasses = function () {
                var msc = JSON.parse(JSON.stringify(_this.userFlags.matchScoreClasses));
                var r = msc.filter(function (matchScoreObj) {
                        return String(matchScoreObj.value) == 'true';
                    })
                    .map(function (matchScoreObj) {
                        if(String(matchScoreObj.value) == 'true'){
                            return matchScoreObj.label;
                        }
                    });

                return r;
            };

            var getDefaultAlertSettings = function () {
                return {text: true, email: false};
            };

            var getGlobalAlertSettings = function () {
                var r = getDefaultAlertSettings();
                if(_.has($user, 'settings.alerts.email')){
                    r.email = $user.settings.alerts.email;
                }
                if(_.has($user, 'settings.alerts.text')){
                    r.text = $user.settings.alerts.text;
                }

                return r;
            };

            var getFavoritesAlertSettings = function () {
                var r = getDefaultAlertSettings();
                if(_.has($user, 'settings.alerts.favorites')){
                    r = _.extend(r, $user.settings.alerts.favorites);
                }
                return {alerts: r};
            };

            var getFilterAlertSettings = function () {
                var r = [];
                var filters = JSON.parse(JSON.stringify($user.filters || []));
                if(filters && angular.isArray(filters) && filters.length > 0) {
                    r = filters.map(function (filter, i) {
                            return {
                                id: filter.id,
                                name: filter.name,
                                alerts: filter.alerts || getDefaultAlertSettings()
                            };
                        });
                }
                return r;
            };

            var getFilterSavePromise = function (filter) {
                var filterSavePromise = $user.getSearchFilter(filter.id)
                    .then(function (response) {
                        response.alerts = filter.alerts;
                        return response.save();
                    });

                return filterSavePromise;
            };

            var updateAllFilterAlertSettings = function () {
                if(_this.userFlags.filters && _this.userFlags.filters.length > 0) {
                    angular.forEach(_this.userFlags.filters, function (filter, i) {
                        this.push(getFilterSavePromise(filter));
                    }, _this.$promises);
                }
            };

            var updateUserSettings = function () {
                var settingsUpdateObj = {
                    alerts:{
                        match_score_classes: setMatchScoreClasses(),
                        favorites: JSON.parse(JSON.stringify(_this.userFlags.favorites.alerts)),
                        text: _this.userFlags.globalAlertSettings.text,
                        email: _this.userFlags.globalAlertSettings.email
                    }
                };

                $user.settings = angular.extend({}, $user.settings, settingsUpdateObj);
                _this.$promises.push($user.save());
            };

            var trackNotificationSettingsSaveClick = function () {
                var src = ['text', 'email']
                    .filter(function (keyName) {
                        return (String(_this.userFlags.globalAlertSettings[keyName]) === 'true');
                    })
                    .map(function (keyName) {
                        return [$filter('capitalize')(keyName), 'Me'].join(' ');
                    })
                    .join(', ');

                var eventName = 'Notification Settings Save Click';
                var eventData = {
                    'Source': src || 'None Selected'
                };

                $analytics.eventTrack(eventName, eventData);
            };

            var onSubmitSuccess = function (response) {
                $log.debug('All saved!', response);
                $fsloading.hide();
                $thankyouModal('Your changes have been saved.');
            };

            var onSubmitError = function (err) {
                $log.error('An error occurred while trying to save settings: ', err);
                $fsloading.hide();
                $errorModal();
            };

            var initUserFlags = function () {
                _this.userFlags = {
                    matchScoreClasses: getMatchScoreClasses(),
                    filters: getFilterAlertSettings(),
                    favorites: getFavoritesAlertSettings(),
                    globalAlertSettings: getGlobalAlertSettings(),
                    verifiedPhone: hasVerified('phone'),
                    verifiedEmail: hasVerified('email')
                };
            };

            var validateForm = function () {
                return true;
            };

            var init = function () {
                _this.$promises = [];
                _this.usr = JSON.parse(JSON.stringify($user));
                initUserFlags();
            };

            init();



            /// PUBLIC FUNCTIONS

            _this.resetForm = function () {
                initUserFlags();
            };

            _this.submitForm = function () {
                if(validateForm()) {
                    $fsloading.show();
                    updateAllFilterAlertSettings();
                    updateUserSettings();
                    trackNotificationSettingsSaveClick();

                    $q.all(_this.$promises)
                        .then(onSubmitSuccess)
                        .catch(onSubmitError)
                        .finally(function () {
                            _this.$promises = [];
                        });
                }
            };

            _this.verifiedEmailCheck = function (parent, val) {
                if(String(val) === 'true'){
                    if(!($user && $user.email && $user.email.length > 0)) {
                        $addEmailModal()
                            .then(function (response) {
                                $log.debug('Email Added! ', response);
                            })
                            .catch(function (err) {
                                parent.email = false;
                                $errorModal();
                                $log.error('Something went wrong while trying to save the email and send verification.', err);
                            });
                    } else if(!hasVerified('email')) {
                        $verifyModal();
                    }
                }
            };

            _this.resendTextVerification = function () {
                $fsloading.show();

                $user.sendPhoneVerification($location.absUrl())
                    .then(function (response) {
                        $thankyouModal('You will now receive a notification with a confirmation link. Once received through text or email, just click the link to verify your account. Please note: This link will expire in 24hrs.');
                    })
                    .catch(function onPhoneVerificationError(err) {
                        $errorModal();
                        $log.error(err);
                    })
                    .finally(function () {
                        $fsloading.hide();
                    });
            };

            _this.resendEmailVerification = function () {
                $fsloading.show();

                $user.sendEmailVerification($location.absUrl())
                    .then(function (response) {
                        $thankyouModal('You will now receive a notification with a confirmation link. Once received through text or email, just click the link to verify your account. Please note: This link will expire in 24hrs.');
                    })
                    .catch(function onPhoneVerificationError(err) {
                        $errorModal();
                        $log.error(err);
                    })
                    .finally(function () {
                        $fsloading.hide();
                    });
            };


            //// WATCHERS

            $scope.$watch(function (scope) {
                return _this.usr.verified.email;
            }, function (newVal, oldVal) {
                if(newVal !== oldVal) {
                    _this.userFlags.verifiedEmail = hasVerified('email');
                }
            });

            $scope.$watch(function (scope) {
                return _this.usr.verified.phone;
            }, function (newVal, oldVal) {
                if(newVal !== oldVal) {
                    _this.userFlags.verifiedPhone = hasVerified('phone');
                }
            });


            $scope.$watch(function (scope) {
                return $user;
            }, function (newVal, oldVal) {
                _this.usr = JSON.parse(JSON.stringify($user));
            }, true);
        }
    ],
    template: require('./index.html')
});
